import { render, staticRenderFns } from "./UpdatePrompt.vue?vue&type=template&id=6235d14c&scoped=true"
import script from "./UpdatePrompt.vue?vue&type=script&lang=js"
export * from "./UpdatePrompt.vue?vue&type=script&lang=js"
import style0 from "./UpdatePrompt.vue?vue&type=style&index=0&id=6235d14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235d14c",
  null
  
)

export default component.exports